// @greenlight-spec: 28-it-dashboard-ui.md#internal-health--internal-health-org-admin

/** The viewer's own zone, named once on the section so every time below it reads plainly. */
export function viewerTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

const MOMENT = new Intl.DateTimeFormat(undefined, {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZoneName: 'short',
});

const DAY = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' });
const TIME = new Intl.DateTimeFormat(undefined, { hour: '2-digit', minute: '2-digit' });

/** A full, unambiguous moment for tooltips and the data table. */
export function formatMoment(ms: number): string {
  return MOMENT.format(new Date(ms));
}

/** The window's two ends, as an axis caption: a date for long ranges, a time for short ones. */
export function formatWindowEdge(ms: number, windowMs: number): string {
  const d = new Date(ms);
  return windowMs > 86_400_000 ? DAY.format(d) : `${DAY.format(d)} ${TIME.format(d)}`;
}
